import { Outlet, useLocation } from "react-router-dom";
import SideBar from "./Components/SideBar";
import OnDemandSideBar from "./Components/OnDemandSideBar";
import Notification from "./Components/Dialogs/Notification";
import LanguageSwitcher from "./Components/LanguageSwitcher";
import { useEffect } from "react";
import { useMyContext } from "./context";
import useAuth from "./hooks/useAuth";

const Layout = () => {
  const { isAuthenticated } = useMyContext();
  const { showNotificationPermissionDialog, getFCMStatus } = useAuth();
  const fcmStatus = getFCMStatus();
  const location = useLocation();
  const isOnDemand = location.pathname.startsWith("/on-demand");

  useEffect(() => {
    if (isAuthenticated && fcmStatus.permission === "default") {
      setTimeout(() => {
        showNotificationPermissionDialog(true);
      }, 2500);
    }
  }, [isAuthenticated]);

  return (
    <div
      className="bg-[#F4F7F6] min-h-screen flex relative overflow-x-hidden"
    >
      {isOnDemand ? <OnDemandSideBar /> : <SideBar />}
      <div
        className={
          isOnDemand
            ? "outlet-wrapper outlet-wrapper--ondemand xl:pl-4 xl:pr-4 xl:pt-5 xl:pb-6 px-4 pt-5 pb-4 min-w-0 flex-1 relative z-0"
            : "outlet-wrapper 2xl:px-16 xl:pl-12 xl:pr-6 xl:pt-6 xl:pb-8 px-8 pt-6 pb-4 min-w-0 flex-1 relative z-0"
        }
      >
        <Outlet />
      </div>
      {/* Mobile: always reachable without opening the sidebar */}
      <div className="fixed top-4 right-4 z-[70] xl:hidden">
        <LanguageSwitcher />
      </div>
      <div
        className="notification-permission-container"
        style={{
          position: "absolute",
          right: "20px",
          top: "72px",
          zIndex: 1000,
        }}
      />
      <Notification />
    </div>
  );
};

export default Layout;
